import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './contexts/AuthContext';
import { ConfirmationServiceProvider } from './hooks/ConfirmationService';
import { I18nextProvider } from 'react-i18next';
import { AppFallback, ErrorBoundary } from './elements';
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary/ChunkErrorBoundary';
import { AppUpdateShell } from './components/AppUpdateShell/AppUpdateShell';
import i18n from './hooks/i18n';
import { AppThemeProvider } from './theme/AppThemeProvider';

createRoot(document.getElementById('root')!).render(
  <ChunkErrorBoundary>
    {/* Outside everything that draws: the loading fallback, the confirmation dialog and the update banner
        render above <App /> and would otherwise fall back to MUI's default palette. */}
    <AppThemeProvider>
      <React.Suspense fallback={<AppFallback />}>
        <AuthProvider>
          <ErrorBoundary>
            <I18nextProvider i18n={i18n}>
              <ConfirmationServiceProvider>
                <AppUpdateShell>
                  <App />
                </AppUpdateShell>
              </ConfirmationServiceProvider>
            </I18nextProvider>
          </ErrorBoundary>
        </AuthProvider>
      </React.Suspense>
    </AppThemeProvider>
  </ChunkErrorBoundary>
);

// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
